import { useIntl } from 'react-intl'

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB']

function FormattedBytes({ value }) {
  const intl = useIntl()

  if (value == null) {
    return null
  }

  if (value === 0) {
    return '0 B'
  }

  const k = 1024
  const i = Math.floor(Math.log(value) / Math.log(k))
  const formattedValue = intl.formatNumber(value / Math.pow(k, i), {
    maximumFractionDigits: 1,
  })

  return `${formattedValue} ${UNITS[i]}`
}

export default FormattedBytes
